import { h } from 'preact';
import { useState, useRef, useLayoutEffect, useEffect } from 'preact/hooks';

let ctxt, f, fs, gs;
function initialize() {
  /* global exsurge */
  ctxt = new exsurge.ChantContext(exsurge.TextMeasuringStrategy.Canvas);
  ctxt.lyricTextFont = "'Crimson Text', serif";
  ctxt.specialCharProperties['font-family'] = 'FancyVR';
  ctxt.lyricTextSize *= 1.2;
  ctxt.dropCapTextFont = ctxt.lyricTextFont;
  ctxt.annotationTextFont = ctxt.lyricTextFont;
  f = ctxt.lyricTextFont;
  fs = ctxt.lyricTextSize;
  gs = ctxt.glyphScaling;
}
if (typeof exsurge === 'object') initialize();

const renders = [];
export const gabc = function(p) {
  if (!ctxt) return h('div', null, 'gabc/exsurge not available');
  const ref = useRef();
  /* eslint-disable-next-line no-unused-vars */
  const [show, setShow] = useState(false);
  useEffect(() => {
    const doRender = () => setShow(s => !s);
    window.addEventListener('resize', doRender);
    renders.push(doRender);
    return () => window.removeEventListener('resize', doRender);
  }, []);
  useLayoutEffect(() => {
    const gabc2 = gabcToExsurge(p.gabc);
    console.log(gabc2);
    layoutChant(gabc2, ref.current, !!p.cap);
  });
  return h('div', { ref });
};

export function gabcResize(gx) {
  if (!ctxt) return;
  ctxt.setFont(f, fs * gx);
  ctxt.setGlyphScaling(gs * gx);
  renders.forEach(x => x());
}

function layoutChant(gabc2, parentEl, initStyle) {
  const mappings = exsurge.Gabc.createMappingsFromSource(ctxt, gabc2);
  const score = new exsurge.ChantScore(ctxt, mappings, initStyle);
  score.performLayoutAsync(ctxt, function() {
    let width = parentEl.getBoundingClientRect().width;
    const responsiveSVG = !!width;
    /* global chantContainer */
    if (!width) width = chantContainer.clientWidth;
    score.layoutChantLines(ctxt, width, function() {
      const svg = score.createSvgNode(ctxt);
      if (responsiveSVG) {
        svg.removeAttribute('width');
        svg.removeAttribute('height');
      } else {
        svg.removeAttribute('viewBox');
      }
      parentEl.innerHTML = '';
      parentEl.appendChild(svg);
    });
  });
}

function gabcToExsurge(gabc2) {
  // character doesn't work in the bold version of this font.
  return gabc2.replace(/(<b>[^<]+)<sp>'(?:oe|œ)<\/sp>/g, '$1œ</b>\u0301<b>')
    .replace(/<v>\\vv<\/v>/g, 'V/.')
    .replace(/<v>\\rr<\/v>/g, 'R/.')
    .replace(/<v>\\([VRAvra])bar<\/v>/g, '$1/.')
    .replace(/<sp>([VRAvra])\/<\/sp>\.?/g, '$1/.')
    .replace(/<b><\/b>/g, '')
    .replace(/<sp>'(?:ae|æ)<\/sp>/g, 'ǽ')
    .replace(/<sp>'(?:oe|œ)<\/sp>/g, 'œ́')
    .replace(/<v>\\greheightstar<\/v>/g, '*')
    .replace(/<\/?sc>/g, '%')
    .replace(/<\/?b>/g, '*')
    .replace(/<\/?i>/g, '_')
    .replace(/(\s)_([^\s*]+)_(\(\))?(?=\s)/g, '$1^_$2_^$3')
    .replace(/(\([cf][1-4]\)|\s)(\d+\.)(\s\S)/g, '$1^$2^$3');
}
